import React, { MutableRefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Box, Button, FormField } from '@chargify/custom-ui-components';
import { CustomField, renderField } from '@chargify/custom-fields';

type CustomFieldsFormProps = {
  customFields: CustomField[];
  onChange: (id: number, value: string | number) => void;
  onSave: () => void;
  onCancel: () => void;
  isSaving: boolean;
  isError: boolean;
  portalContainer?: MutableRefObject<HTMLDivElement>;
};

const CustomFieldsForm = ({
  customFields,
  onChange,
  onSave,
  onCancel,
  isSaving,
  isError,
  portalContainer,
}: CustomFieldsFormProps) => {
  const { t } = useTranslation(['customer-details']);

  return (
    <>
      {isError && (
        <Box marginBottom={5}>
          <Alert color="danger">
            <Alert.TextMessage>
              {t('error.we_were_unable_to_save_your_custom_fields')}
            </Alert.TextMessage>
          </Alert>
        </Box>
      )}
      {customFields.map(({ name, id, fieldType, value, enum: options }) => (
        <FormField label={name} name={name} key={id} fullWidth>
          {renderField({
            portalContainer,
            id,
            name,
            fieldType,
            value: value || '',
            options,
            onChange,
            maxLength: 2048,
          })}
        </FormField>
      ))}
      <Box marginTop={3}>
        <Button.Group>
          <Button
            label={t('custom_fields.update_additional_settings')}
            color={'primary'}
            onClick={onSave}
            isLoading={isSaving}
          />
          <Button
            label={t('cancel', { ns: 'common' })}
            color={'secondary'}
            onClick={onCancel}
          />
        </Button.Group>
      </Box>
    </>
  );
};

export default CustomFieldsForm;
